import React, { useState, useEffect, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCopy,
  faEdit,
  faEllipsisH,
  faEye,
  faFilePdf,
  faList,
  faStickyNote,
  faTrashAlt,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import {
  Button,
  Nav,
  Card,
  Table,
  Pagination,
  ButtonGroup,
  Modal,
  Dropdown,
  Form,
  Row,
  Col,
  Alert,
  ProgressBar,
} from "@themesberg/react-bootstrap";
import axios from "axios";
import { Routes } from "../routes";
import { Link, useLocation } from "react-router-dom";
import { faCheckCircle, faExclamationCircle } from "@fortawesome/free-solid-svg-icons";

import { jsPDF } from "jspdf";
import BASE_URL from "../config";












export const ApplicationTable = () => {
  const location = useLocation(); // Access the URL query parameters

  const [autoReply, setAutoReply] = useState(false);
  const [applicationStatus, setApplicationStatus] = useState("0");
  const [applications, setApplications] = useState([]); // State for fetched data
  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state
  const [showDefault, setShowDefault] = useState(false); // Modal state for notes
  const [showDefaults, setShowDefaultupdate] = useState(false); // Modal state for status update
  const [message, setMessage] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false); // Modal state for delete confirmation
  const [deleteId, setDeleteId] = useState(null); // Store the ID of the application to be deleted
  const [deleteSuccessMessage, setDeleteSuccessMessage] = useState(""); // Store success message
  const [selectedApplicationId, setSelectedApplicationId] = useState(null); // State to hold the selected application ID
  const [selectedApplications, setSelectedApplications] = useState([]); // Track selected applications
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [bulkStatus, setBulkStatus] = useState("");
  const [currentPage, setCurrentPage] = useState(1); // Current active page
  const applicationsPerPage = 5; // Applications per page
  const [totalPages, setTotalPages] = useState(1); // Total pages (initialize it as 1)
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredApplications, setFilteredApplications] = useState([]);
  // Fetch the logged-in user from localStorage
  const loggedInUser = JSON.parse(localStorage.getItem("authToken")); // Adjust the key if needed
  const isAdmin = loggedInUser && loggedInUser.user_type === "1"; // Check if the user is admin



  const [showPopup, setShowPopup] = useState(false);
  const [popupType, setPopupType] = useState(""); // "success" or "error"
  const [popupMessage, setPopupMessage] = useState("");
  const [countdown, setCountdown] = useState(3); // Countdown in seconds
  const [showDefaultUpdate, setShowDefaultUpdate] = useState(false);



  const downloadPDF = (applicationId) => {
    const application = applications.find(
      (app) => Number(app.id) === Number(applicationId)
    );

    if (!application) {
      console.error("Application not found");
      return;
    }

    const doc = new jsPDF("p", "mm", "a4");

    // --------------------------------------------------
    // PAGE SETTINGS
    // --------------------------------------------------
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const marginLeft = 15;
    const marginRight = 15;
    const contentWidth = pageWidth - marginLeft - marginRight;

    // Column widths
    const labelWidth = 62;
    const valueWidth = contentWidth - labelWidth;

    let y = 15;

    // --------------------------------------------------
    // HELPER: FORMAT FIELD NAME
    // --------------------------------------------------
    const formatFieldName = (key) => {
      return key
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase());
    };

    // --------------------------------------------------
    // HELPER: FORMAT VALUE
    // --------------------------------------------------
    const formatValue = (value) => {
      if (value === null || value === undefined || value === "") {
        return "N/A";
      }

      if (typeof value === "object") {
        return Object.entries(value)
          .map(
            ([nestedKey, nestedValue]) =>
              `${formatFieldName(nestedKey)}: ${
                nestedValue === null ||
                nestedValue === undefined ||
                nestedValue === ""
                  ? "N/A"
                  : nestedValue
              }`
          )
          .join("\n");
      }

      return String(value);
    };

    // --------------------------------------------------
    // FOOTER
    // --------------------------------------------------
    const addFooter = () => {
      const pageNumber = doc.internal.getNumberOfPages();

      doc.setFontSize(9);
      doc.setTextColor(120);

      doc.text(
        `Application ID: ${application.id}`,
        marginLeft,
        pageHeight - 10
      );

      doc.text(
        `Page ${pageNumber}`,
        pageWidth - marginRight,
        pageHeight - 10,
        { align: "right" }
      );

      doc.setTextColor(0);
    };

    // --------------------------------------------------
    // HEADER
    // --------------------------------------------------

    // Main title
    doc.setFont("helvetica", "bold");
    doc.setFontSize(20);
    doc.setTextColor(30, 30, 30);

    doc.text("Application Details", marginLeft, y);

    y += 10;

    // Application ID
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.setTextColor(100);

    doc.text(
      `Application ID: ${application.id}`,
      marginLeft,
      y
    );

    // Generated date
    const generatedDate = new Date().toLocaleString();

    doc.text(
      `Generated: ${generatedDate}`,
      pageWidth - marginRight,
      y,
      { align: "right" }
    );

    y += 8;

    // Horizontal line
    doc.setDrawColor(180);
    doc.line(
      marginLeft,
      y,
      pageWidth - marginRight,
      y
    );

    y += 8;

    // --------------------------------------------------
    // TABLE HEADER
    // --------------------------------------------------

    doc.setFillColor(240, 242, 245);
    doc.rect(
      marginLeft,
      y,
      contentWidth,
      10,
      "F"
    );

    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.setTextColor(40);

    doc.text(
      "Application Field",
      marginLeft + 4,
      y + 6.5
    );

    doc.text(
      "Details",
      marginLeft + labelWidth + 4,
      y + 6.5
    );

    y += 10;

    // --------------------------------------------------
    // APPLICATION DATA
    // --------------------------------------------------

    Object.entries(application).forEach(([key, value], index) => {
      const label = formatFieldName(key);
      const formattedValue = formatValue(value, key);

      // Split long text so it wraps inside the value column
      const labelLines = doc.splitTextToSize(
        label,
        labelWidth - 8
      );

      const valueLines = doc.splitTextToSize(
        formattedValue,
        valueWidth - 8
      );

      const lineCount = Math.max(
        labelLines.length,
        valueLines.length
      );

      const lineHeight = 5;

      const rowHeight =
        Math.max(10, lineCount * lineHeight + 6);

      // --------------------------------------------------
      // PAGE BREAK
      // --------------------------------------------------

      if (y + rowHeight > pageHeight - 20) {
        addFooter();

        doc.addPage();

        y = 20;

        // Table header again on new page
        doc.setFillColor(240, 242, 245);

        doc.rect(
          marginLeft,
          y,
          contentWidth,
          10,
          "F"
        );

        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        doc.setTextColor(40);

        doc.text(
          "Application Field",
          marginLeft + 4,
          y + 6.5
        );

        doc.text(
          "Details",
          marginLeft + labelWidth + 4,
          y + 6.5
        );

        y += 10;
      }

      // --------------------------------------------------
      // ALTERNATING ROW BACKGROUND
      // --------------------------------------------------

      if (index % 2 === 0) {
        doc.setFillColor(250, 250, 250);

        doc.rect(
          marginLeft,
          y,
          contentWidth,
          rowHeight,
          "F"
        );
      }

      // --------------------------------------------------
      // ROW BORDERS
      // --------------------------------------------------

      doc.setDrawColor(220);

      // Outer horizontal line
      doc.line(
        marginLeft,
        y + rowHeight,
        marginLeft + contentWidth,
        y + rowHeight
      );

      // Vertical column separator
      doc.line(
        marginLeft + labelWidth,
        y,
        marginLeft + labelWidth,
        y + rowHeight
      );

      // Left border
      doc.line(
        marginLeft,
        y,
        marginLeft,
        y + rowHeight
      );

      // Right border
      doc.line(
        marginLeft + contentWidth,
        y,
        marginLeft + contentWidth,
        y + rowHeight
      );

      // --------------------------------------------------
      // FIELD NAME
      // --------------------------------------------------

      doc.setFont("helvetica", "bold");
      doc.setFontSize(9);
      doc.setTextColor(60);

      doc.text(
        labelLines,
        marginLeft + 4,
        y + 6
      );

      // --------------------------------------------------
      // VALUE
      // --------------------------------------------------

      doc.setFont("helvetica", "normal");
      doc.setFontSize(9);
      doc.setTextColor(40);

      doc.text(
        valueLines,
        marginLeft + labelWidth + 4,
        y + 6
      );

      y += rowHeight;
    });

    // --------------------------------------------------
    // FOOTER FOR LAST PAGE
    // --------------------------------------------------

    addFooter();

    // --------------------------------------------------
    // SAVE PDF
    // --------------------------------------------------

    doc.save(`Application_${application.id}.pdf`);
  };
  
  
  


  // Define a variable that checks if the logged-in user is Admin or Merchant
  const isAdminOrMerchant =
    loggedInUser &&
    (loggedInUser.user_type === "0" || loggedInUser.user_type === "1");

  // New code using applicationsPerPage
  const indexOfLastItem = currentPage * applicationsPerPage;
  const indexOfFirstItem = indexOfLastItem - applicationsPerPage;

  const currentApplications = filteredApplications.slice(
    indexOfFirstItem,
    indexOfLastItem
  );


  const urlParams = new URLSearchParams(location.search);
  const searchId = urlParams.get("applicationId");

  // Set the search query to the 'id' from the URL if available
  useEffect(() => {
    if (searchId) {
      setSearchQuery(searchId); // Set the search query to the 'id' from URL
    }
  }, [searchId]);


  useEffect(() => {
    setTotalPages(Math.ceil(filteredApplications.length / applicationsPerPage));
  }, [filteredApplications]);
  useEffect(() => {
    setCurrentPage(1);
    // console.log(applications);
  }, [filteredApplications]);

  const handleStatusChange = (e) => {
    setApplicationStatus(e.target.value);
  };

  
  
  
  
  
  
  
  useEffect(() => {
    if (showPopup) {
      setCountdown(2); // Reset countdown
      const interval = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);

      const timer = setTimeout(() => {
        clearInterval(interval);

        // Wait 1 additional second after countdown finishes
        setTimeout(() => {
          setShowPopup(false);
        }, 1000);
      }, 3000);

      return () => {
        clearInterval(interval);
        clearTimeout(timer);
      };
    }
  }, [showPopup]);

  // const handleSave = async (applicationId) => {
  //   if (!applicationId) {
  //     setPopupType("error");
  //     setPopupMessage("No application selected.");
  //     setShowPopup(true);
  //     return;
  //   }
  //   // setLoading(true);

  //   try {
  //     // Update application status
  //     const response = await axios.put(`${BASE_URL}/api.php`, {
  //       type: "updateApplicationStatus",
  //       id: applicationId,
  //       application_status: applicationStatus,
  //       updated_by_userId: loggedInUser.id, // Pass the logged-in user ID
  //     });

  //     if (response.data.message) {
  //       setPopupType("success");
  //       setPopupMessage("Application status updated successfully!");
  //       setShowPopup(true);
  //       handleClose();
  //       handleCloses();
  //       try {
  //         // Send notification after successful status update
  //         const statusMessages = {
  //           "0": "Application Approved",
  //           "1": "Application Declined",
  //           "2": "Application Suspended",
  //           "3": "Incomplete Application",
  //           "4": "Waiting For Merchant",
  //           "5": "Waiting For Bank",
  //           "6": "Waiting For Agent",
  //           "7": "Application Applied",
  //         };

  //         const statusMessage = statusMessages[applicationStatus] || "Unknown Status";
  //         const application = applications.find((app) => app.id === applicationId);
  //         if (!application) {
  //           setPopupType("error");
  //           setPopupMessage("Application not found.");
  //           setShowPopup(true);
  //           return;
  //         }

  //         const email = application.user_email;
  //         const notificationPayload = {
  //           type: "AddNotification",
  //           email: email,
  //           title: `Application Status Updated for Application id ${applicationId}`,
  //           message: `The application status has been updated to: ${statusMessage}.`,
  //         };

  //         await axios.post(`${BASE_URL}/api.php`, notificationPayload);
  //         alert("Notification sent successfully!");
  //       } catch (e) {
  //         setPopupType("error");
  //         setPopupMessage("Error sending the notification.");
  //         setShowPopup(true);
  //       }

  //       setShowDefaultUpdate(false);
  //       await fetchApplications(); // Refetch applications after update
  //     } else {
  //       setPopupType("error");
  //       setPopupMessage("Failed to update application status.");
  //       setShowPopup(true);
  //     }
  //   } catch (error) {
  //     setPopupType("error");
  //     setPopupMessage("Error updating application status.");
  //     setShowPopup(true);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  

  // Handle form submit to update application status for selected applications
  // const handleBulkSave = async () => {
  //   if (selectedApplications.length === 0) {
  //     alert("No applications selected.");
  //     return;
  //   }

  //   if (!bulkStatus) {
  //     alert("Please select a status to apply.");
  //     return;
  //   }

  //   setLoading(true);
  //   try {
  //     // Send the selected status and application IDs to the backend for bulk update
  //     const response = await axios.put(`${BASE_URL}/api.php`, {
  //       type: "bulkUpdateApplicationStatus", // Define the type as 'bulkUpdate'
  //       ids: selectedApplications, // Send the selected application IDs
  //       application_status: bulkStatus, // Send the updated status
  //     });

  //     // Capture the backend response and show a success or error message
  //     if (response.data.message) {
  //       alert(response.data.message); // Success alert
  //       setSelectedApplications([]); // Clear selected applications after the update
  //       setIsSelectAll(false); // Reset the Select All state
  //       setBulkStatus(""); // Clear the bulk status dropdown
  //       setLoading(false);
  //       await fetchApplications();
  //     } else {
  //       alert("Failed to update application statuses.");
  //     }
  //   } catch (error) {
  //     console.error("Error updating application statuses:", error);
  //     setMessage({
  //       type: "error",
  //       text: "Error updating application statuses.",
  //     });
  //   } finally {
  //     setLoading(false);
  //   }
  // };



//  Working
  // const handleBulkSave = async () => {
  //   if (selectedApplications.length === 0) {
  //     alert("No applications selected.");
  //     return;
  //   }

  //   if (!bulkStatus) {
  //     alert("Please select a status to apply.");
  //     return;
  //   }

  //   setLoading(true);
  //   try {
  //     const response = await axios.put(`${BASE_URL}/api.php`, {
  //       type: "bulkUpdateApplicationStatus",
  //       ids: selectedApplications, // Selected application IDs
  //       application_status: bulkStatus, // New status
  //       updated_by_userId: loggedInUser.id, // Logged-in user ID
  //     });

  //     if (response.data.status === "success") {
  //       alert(response.data.message);
  //       setSelectedApplications([]); // Clear selections
  //       setIsSelectAll(false); // Reset "Select All" state
  //       setBulkStatus(""); // Clear the status dropdown
  //       await fetchApplications(); // Refresh the applications list
  //     } else {
  //       alert(
  //         response.data.message || "Failed to update application statuses."
  //       );
  //     }
  //   } catch (error) {
  //     console.error("Error updating application statuses:", error);
  //     alert("An error occurred while updating application statuses.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleSave = async (applicationId) => {
  if (!applicationId) {
    setPopupType("error");
    setPopupMessage("No application selected.");
    setShowPopup(true);
    return;
  }

  setLoading(true);

  try {
    const response = await axios.put(
      `${BASE_URL}/api.php`,
      {
        type: "updateApplicationStatus",
        id: applicationId,
        application_status: applicationStatus,
        updated_by_userId: loggedInUser.id,
      }
    );

    console.log("STATUS UPDATE RESPONSE:", response.data);
    console.log("HTTP STATUS:", response.status);

    if (response.data.status === "success") {
      setPopupType("success");

      if (response.data.email_status === "sent") {
        setPopupMessage(
          "Application status updated and auto-reply email sent successfully!"
        );
      } else if (response.data.email_status === "failed") {
        setPopupMessage(
          "Application status updated, but auto-reply email failed."
        );
      } else {
        setPopupMessage(
          "Application status updated successfully!"
        );
      }

      setShowPopup(true);

      // Close update modal
      setShowDefaultupdate(false);

      // Reset selected application
      setSelectedApplicationId(null);

      // Refresh list
      await fetchApplications();

    } else {
      console.log("BACKEND RETURNED NON-SUCCESS:", response.data);

      setPopupType("error");
      setPopupMessage(
        response.data.message ||
        "Failed to update application status."
      );
      setShowPopup(true);
    }

  } catch (error) {
    console.error("STATUS UPDATE ERROR:", error);

    console.error("ERROR RESPONSE:", error.response?.data);
    console.error("ERROR STATUS:", error.response?.status);

    setPopupType("error");
    setPopupMessage(
      error.response?.data?.message ||
      "Error updating application status."
    );

    setShowPopup(true);

  } finally {
    setLoading(false);
  }
};

  // const handleBulkSave = async () => {
  //   if (selectedApplications.length === 0) {
  //     alert("No applications selected.");
  //     return;
  //   }
  
  //   if (!bulkStatus) {
  //     alert("Please select a status to apply.");
  //     return;
  //   }
  
  //   setLoading(true);
  //   try {
  //     // Bulk update application statuses
  //     const response = await axios.put(`${BASE_URL}/api.php`, {
  //       type: "bulkUpdateApplicationStatus",
  //       ids: selectedApplications, // Selected application IDs
  //       application_status: bulkStatus, // New status
  //       updated_by_userId: loggedInUser.id, // Logged-in user ID
  //     });
  
  //     if (response.data.status === "success") {
  //       alert(response.data.message);
  
  //       // Status Messages Map
  //       const statusMessages = {
  //         "0": "Application Approved",
  //         "1": "Application Declined",
  //         "2": "Application Suspended",
  //         "3": "Incomplete Application",
  //         "4": "Waiting For Merchant",
  //         "5": "Waiting For Bank",
  //         "6": "Waiting For Agent",
  //         "7": "Application Applied",
  //       };
  
  //       const statusMessage = statusMessages[bulkStatus] || "Unknown Status";
  
  //       // Send notifications to `application.user_email`
  //       for (const appId of selectedApplications) {
  //         const application = applications.find((app) => app.id === appId);
  //         if (!application) {
  //           console.error(`Application with ID ${appId} not found.`);
  //           continue;
  //         }
  
  //         const email = application.user_email;
  
  //         const notificationPayload = {
  //           type: "AddNotification",
  //           email: email,
  //           title: `Application Status Updated for Application id ${appId}`,
  //           message: `The application status has been updated to: ${statusMessage}.`,
  //         };
  
  //         try {
  //           const notificationResponse = await axios.post(`${BASE_URL}/api.php`, notificationPayload);
  //         } catch (error) {
  //           console.error(`Error sending notification for Application ID: ${appId}`, error);
  //         }
  //       }
  
  //       // Fetch emails from the new API
  //       const emailResponse = await axios.get(`${BASE_URL}/api.php?type=fetchUserEmails`);
  //       if (emailResponse.data.status === "success") {
  //         const emails = emailResponse.data.emails;
  
  //         // Send notifications for all updated applications to fetched emails
  //         for (const appId of selectedApplications) {
  //           const application = applications.find((app) => app.id === appId);
  //           if (!application) {
  //             console.error(`Application with id ${appId} not found.`);
  //             continue;
  //           }
  
  //           for (const email of emails) {
  //             const notificationPayload = {
  //               type: "AddNotification",
  //               email: email,
  //               title: `Application Status Updated for Application id ${appId}`,
  //               message: `The application status has been updated to: ${statusMessage}.`,
  //             };
  
  //             try {
  //               const notificationResponse = await axios.post(`${BASE_URL}/api.php`, notificationPayload);
  //               console.log(
  //                 `Notification sent successfully to: ${email} for Application ID: ${appId}`,
  //                 notificationResponse.data
  //               );
  //             } catch (error) {
  //               console.error(
  //                 `Error sending notification to: ${email} for Application ID: ${appId}`,
  //                 error
  //               );
  //             }
  //           }
  //         }
  //       } else {
  //         console.error("Error fetching user emails:", emailResponse.data.message);
  //       }
  
  //       // Clear selections and reset state
  //       setSelectedApplications([]);
  //       setIsSelectAll(false);
  //       setBulkStatus("");
  //       await fetchApplications();
  //     } else {
  //       alert(response.data.message || "Failed to update application statuses.");
  //     }
  //   } catch (error) {
  //     console.error("Error updating application statuses:", error);
  //     alert("An error occurred while updating application statuses.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  
  const handleBulkSave = async () => {

    if (selectedApplications.length === 0) {
      alert("No applications selected.");
      return;
    }

    if (!bulkStatus) {
      alert("Please select a status to apply.");
      return;
    }

    setLoading(true);

    try {

      const response = await axios.put(
        `${BASE_URL}/api.php`,
        {
          type: "bulkUpdateApplicationStatus",
          ids: selectedApplications,
          application_status: bulkStatus,
          updated_by_userId: loggedInUser.id,
        }
      );

      if (response.data.status === "success") {

        const sent = response.data.emails_sent || 0;
        const failed = response.data.emails_failed || 0;

        setPopupType("success");

        setPopupMessage(
          `Applications updated successfully. ${sent} auto-reply email(s) sent${failed > 0 ? `, ${failed} failed.` : "."}`
        );

        setShowPopup(true);

        setSelectedApplications([]);
        setIsSelectAll(false);
        setBulkStatus("");

        await fetchApplications();

      } else {

        setPopupType("error");

        setPopupMessage(
          response.data.message ||
          "Failed to update application statuses."
        );

        setShowPopup(true);
      }

    } catch (error) {

      console.error(
        "Error updating application statuses:",
        error
      );

      setPopupType("error");
      setPopupMessage(
        "An error occurred while updating application statuses."
      );

      setShowPopup(true);

    } finally {

      setLoading(false);
    }
  };

  // const getApplicationStatusMessage = (status, userName, applicationId) => {
  //   const messages = {
  //     0: "Congratulations! Your application has been approved.",
  //     1: "Unfortunately, your application has been declined.",
  //     2: "Your application has been suspended for further review.",
  //     3: "Your application is incomplete. Please provide the missing details.",
  //     4: "We are waiting for your response to proceed with your application.",
  //     5: "We are waiting for the bank to approve your application.",
  //     6: "We are waiting for the agent's response on your application.",
  //     7: "Your application has been successfully submitted and is under review.",
  //   };

  //   const message =
  //     messages[status] || "Your application status has been updated.";

  //   return `Dear ${userName},

  // ${message} (Application ID: ${applicationId}).

  // Regards,
  // Blueberry Merchant.`;
  // };

  const userTypeMap = {
    0: "Management",
    1: "Admin",
    2: "Applicant",
  };

  useEffect(() => {
    if (searchQuery === "") {
      setFilteredApplications(applications);
    } else {
      const filtered = applications.filter((app) => {
        const userTypeText = userTypeMap[Number(app.user_type)] || "";
        const statusText = statusMap[Number(app.application_status)] || "";
  
        return (
          app.company_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
          userTypeText.toLowerCase().includes(searchQuery.toLowerCase()) ||
          statusText.toLowerCase().includes(searchQuery.toLowerCase()) ||
          app.contactemail.toLowerCase().includes(searchQuery.toLowerCase()) ||
          app.id.toString() === searchQuery // Exact match for id
        );
      });
      setFilteredApplications(filtered);
    }
  }, [searchQuery, applications]);
  

  // Fetch data from the backend
  // useEffect(() => {
  //   const fetchApplications = async () => {
  //     try {
  //       const response = await axios.get(
  //         "/api.php?type=applications"
  //       );
  //       setApplications(response.data);
  //       setLoading(false);
  //     } catch (error) {
  //       setError("Failed to fetch data");
  //       setLoading(false);
  //     }
  //   };
  //   fetchApplications();
  // }, []);
  // Fetch data from the backend

  const fetchApplications = async () => {
    const loggedInUserMail = loggedInUser.email; // Ensure loggedInUser is available
    const loggedInUserType = loggedInUser.user_type; // Ensure loggedInUser is available
    setLoading(true); // Set loading to true while fetching data
    try {
      // Send the email in headers
      const response = await axios.get(`${BASE_URL}/api.php?type=applications`, {
        headers: {
          email: loggedInUserMail,
          user_type: loggedInUserType,
        },
      });

      const data = response.data;

      if (Array.isArray(data)) {
        setApplications(data);
        setTotalPages(Math.ceil(data.length / applicationsPerPage)); // Calculate total pages
      } else {
        setApplications([]);
        setTotalPages(1); // Reset total pages when no data
      }

      setLoading(false);
    } catch (error) {
      setError("Failed to fetch data");
      setLoading(false);
    }
  };

  // Initial data fetch on component mount
  useEffect(() => {
    fetchApplications();
    
    
  }, []);

  // useEffect(() => {
  //   const fetchApplications = async () => {
  //     try {
  //       const response = await axios.get(
  //         "/api.php?type=applications"
  //       );

  //       // Check if the response is an array and set it as the state.
  //       const data = response.data;
  //       if (Array.isArray(data)) {
  //         setApplications(data);
  //       } else {
  //         // If the response is not an array, set `applications` to an empty array.
  //         setApplications([]);
  //       }

  //       setLoading(false);
  //     } catch (error) {
  //       setError("Failed to fetch data");
  //       setLoading(false);
  //     }
  //   };
  //   fetchApplications();
  // }, []);

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${BASE_URL}/api.php`, {
        data: { type: "applications", id },
      });
      setApplications(applications.filter((app) => app.id !== id));
      setShowDeleteModal(false);
      setDeleteSuccessMessage("Application deleted successfully!");

      // Automatically clear the success message after 3 seconds
      setTimeout(() => {
        setDeleteSuccessMessage("");
      }, 3000);
    } catch (error) {
      alert("Failed to delete the application. Please try again.");
    }
    console.log(loggedInUser);
  };

  const handleClose = () => setShowDefault(false);
  const handleCloses = () => setShowDefaultupdate(false);
  const handleDeleteClose = () => setShowDeleteModal(false);
  const confirmDelete = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  // Handle selecting individual applications
  const handleSelectApplication = (id) => {
    const isSelected = selectedApplications.includes(id);
    if (isSelected) {
      setSelectedApplications(
        selectedApplications.filter((appId) => appId !== id)
      );
    } else {
      setSelectedApplications([...selectedApplications, id]);
    }
  };

  // Handle "Select All" functionality
  // const handleSelectAll = () => {
  //   if (isSelectAll) {
  //     setSelectedApplications([]); // Deselect all
  //   } else {
  //     const allApplicationIds = applications.map((app) => app.id);
  //     setSelectedApplications(allApplicationIds); // Select all
  //   }
  //   setIsSelectAll(!isSelectAll); // Toggle "Select All" state
  // };

  const handleSelectAll = () => {
    if (isSelectAll) {
      // Deselect all applications
      setSelectedApplications([]);
    } else {
      // Select all applications across all pages
      setSelectedApplications(applications.map((app) => app.id));
    }
    setIsSelectAll(!isSelectAll); // Toggle "Select All" state
  };

  // Status Mapping
  const statusMap = {
    0: "Application Approved",
    1: "Application Declined",
    2: "Application Suspended",
    3: "Incomplete Application",
    4: "Waiting For Merchant",
    5: "Waiting For Bank",
    6: "Waiting For Agent",
    7: "Application Applied",
  };

  // Render a row for each application
  const TableRow = ({
    id,
    user_type,
    company_name,
    contactemail,
    application_status,
  }) => {
    const isSelected = selectedApplications.includes(id);
    const statusVariant =
      application_status === 0
        ? "success"
        : application_status === 1
        ? "danger"
        : application_status === 2
        ? "warning"
        : "primary";

    return (
      <tr>
        <td>
          <Form.Check
            type="checkbox"
            checked={selectedApplications.includes(id)}
            onChange={() => handleSelectApplication(id)}
          />
        </td>
        <td>
          <Card.Link
            as={Link}
            to={Routes.ViewApplication.path.replace(":id", id)}
            className="fw-normal"
          >
            {id}
          </Card.Link>
        </td>
        <td>
          <span className="fw-normal">
            {/* {user_type == 1 ? "Admin" : "Management"} */}
            {userTypeMap[Number(user_type)] || "Unknown"}
          </span>
        </td>
        <td>
          <span className="fw-normal">{company_name}</span>
        </td>
        <td>
          <span className="fw-normal">{contactemail}</span>
        </td>
        <td>
          <span className={`fw-normal text-${statusVariant}`}>
            {statusMap[application_status]}
          </span>
        </td>
        <td>
           {/* drop="up" align="end"> */}
           <Dropdown as={ButtonGroup}> 
            <Dropdown.Toggle
              as={Button}
              split
              variant="link"
              className="text-dark m-0 p-0"
            >
              <span className="icon icon-sm">
                <FontAwesomeIcon icon={faEllipsisH} className="icon-dark" />
              </span>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {isAdminOrMerchant && (
                <Dropdown.Item
                  className="text-info"
                  as={Link}
                  to={Routes.EditApplication.path.replace(":id", id)}
                >
                  <FontAwesomeIcon icon={faEdit} className="me-2" /> Edit
                </Dropdown.Item>
              )}
              <Dropdown.Item
                className="text-warning"
                as={Link}
                to={Routes.ViewApplication.path.replace(":id", id)}
              >
                <FontAwesomeIcon icon={faEye} className="me-2" /> View
                Application/Timeline
              </Dropdown.Item>
              {isAdminOrMerchant && (
                <Dropdown.Item
                  className="text-quaternary"
                  onClick={() => {
                    setShowDefaultupdate(true);
                    setSelectedApplicationId(id);
    
                  }}
                >
                  <FontAwesomeIcon icon={faList} className="me-2" /> Update
                  Application Status
                </Dropdown.Item>
              )}
              {isAdmin && (
                <Dropdown.Item
                  className="text-danger"
                  onClick={() => confirmDelete(id)}
                >
                  <FontAwesomeIcon icon={faTrashAlt} className="me-2" /> Remove
                </Dropdown.Item>
              )}
               <Dropdown.Item
  className="text-primary"
  onClick={() => downloadPDF(id)} // Pass the ID of the clicked application
>
  <FontAwesomeIcon icon={faFilePdf} className="me-2" /> Download PDF
</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </td>
      </tr>
    );
  };

  if (loading) {
    return <p>Loading...</p>; // Display a loading message
  }

  if (error) {
    return <p>{error}</p>; // Display an error message
  }

  const totalApplications = applications.length;
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  return (

<>

     {/* Popup */}
     {showPopup && (
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          background: "rgba(255, 255, 255, 0.9)",
          borderRadius: "10px",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
          padding: "20px 30px",
          zIndex: 1050,
          textAlign: "center",
        }}
      >
        <FontAwesomeIcon
          icon={popupType === "success" ? faCheckCircle : faExclamationCircle}
          className={popupType === "success" ? "text-success" : "text-danger"}
          size="3x"
        />
        <h5 className="mt-3 fw-bold">{popupMessage}</h5>
        <div className="mt-3">
          <ProgressBar
            now={(countdown / 3) * 100}
            striped
            variant={popupType === "success" ? "success" : "danger"}
            style={{ transition: "width 1s linear" }}
          />
        </div>
      </div>
    )}

    <Card
      border="light"
      className="table-wrapper shadow-lg border-0 applications-card" style={{minHeight: "500px",overflow: "hidden",}}
    >
      <Card.Body className="pt-4">
        {deleteSuccessMessage && (
          <Alert
            variant="success"
            onClose={() => setDeleteSuccessMessage("")}
            dismissible
          >
            {deleteSuccessMessage}
          </Alert>
        )}
        {isAdminOrMerchant && (
          // <div className="d-flex gap-3 p-3 align-items-center ">
          //   <Form.Check
          //     checked={isSelectAll}
          //     onChange={handleSelectAll}
          //     label="Select All"
          //   />
          //   {/* Status Dropdown */}
          //   <Form.Select
          //     className="w-auto"
          //     value={bulkStatus}
          //     onChange={(e) => {
          //       setBulkStatus(e.target.value); // Set bulk status on change
          //     }}
          //     aria-label="Select status to apply"
          //   >
          //     <option value="">Select Status</option>
          //     <option value="0">Application Approved</option>
          //     <option value="1">Application Declined</option>
          //     <option value="2">Application Suspended</option>
          //     <option value="3">Incomplete Application</option>
          //     <option value="4">Waiting For Merchant</option>
          //     <option value="5">Waiting For Bank</option>
          //     <option value="6">Waiting For Agent</option>
          //     <option value="7">Application Applied</option>
          //   </Form.Select>
          //   {bulkStatus && selectedApplications.length > 0 && (
          //     <Button
          //       variant="primary"
          //       onClick={handleBulkSave}
          //       disabled={loading}
          //     >
          //       {loading ? "Saving..." : "Save"}
          //     </Button>
          //   )}
          // </div>

          <div className="d-flex gap-3 p-3 align-items-center">
            <Form.Check
              checked={isSelectAll}
              onChange={handleSelectAll}
              label="Select All"
              style={{ width:"16%" }}
            />
            <Form.Select
              className="w-auto"
              value={bulkStatus}
              onChange={(e) => setBulkStatus(e.target.value)}
              aria-label="Select status to apply"
            >
              <option value="">Select Status</option>
              <option value="0">Application Approved</option>
              <option value="1">Application Declined</option>
              <option value="2">Application Suspended</option>
              <option value="3">Incomplete Application</option>
              <option value="4">Waiting For Merchant</option>
              <option value="5">Waiting For Bank</option>
              <option value="6">Waiting For Agent</option>
              <option value="7">Application Applied</option>
            </Form.Select>
            <Button
              variant="primary"
              onClick={handleBulkSave}
              disabled={
                !bulkStatus || selectedApplications.length === 0 || loading
              }
            >
              {loading ? "Saving..." : "Save"}
            </Button>
            <div className="search-box">
              <FontAwesomeIcon icon={faSearch} className="search-icon" />
              <Form.Control
                type="text"
                placeholder="Search by ID, Company Name, Email, or Status"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="search-input"
                style={{ paddingLeft: "6%" }}
              />
            </div>
          </div>
        )}

        {
          !isAdminOrMerchant && (
            <div className="search-box">
            <FontAwesomeIcon icon={faSearch} className="search-icon" />
            <Form.Control
              type="text"
              placeholder="Search by ID, Company Name, Email, or Status"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="search-input"
              style={{ paddingLeft: "6%", width:"100%" }}
            />
          </div>
          )
        }

      
        <div className="applications-table-scroll">
          <Table hover className="user-table align-items-center table-styled">
            <thead>
              <tr>
                <th className="border-bottom"></th>
                <th className="border-bottom">Application ID</th>
                <th className="border-bottom">User Type</th>
                <th className="border-bottom">Company Name</th>
                <th className="border-bottom">Contact Email</th>
                {/* Change label */}
                <th className="border-bottom">Status</th>
                {/* <th className="border-bottom">Unread Messages</th> */}
                <th className="border-bottom">Action</th>
              </tr>
            </thead>
            <tbody>
              {currentApplications.map((application) => (
                <TableRow
                  key={application.id}
                  id={application.id}
                  {...application}
                />
              ))}
            </tbody>
          </Table>
        </div>

        <Card.Footer className="px-3 border-0 d-lg-flex align-items-center justify-content-between">
          <Nav>
            <Pagination>
              <Pagination.Prev
                disabled={currentPage === 1}
                onClick={() => handlePageChange(currentPage - 1)}
              >
                Previous
              </Pagination.Prev>
              {Array.from({ length: totalPages }, (_, index) => (
                <Pagination.Item
                  key={index + 1}
                  active={index + 1 === currentPage}
                  onClick={() => handlePageChange(index + 1)}
                >
                  {index + 1}
                </Pagination.Item>
              ))}
              <Pagination.Next
                disabled={currentPage === totalPages}
                onClick={() => handlePageChange(currentPage + 1)}
              >
                Next
              </Pagination.Next>
            </Pagination>
          </Nav>
          <small className="fw-bold">
            Showing <b>{totalApplications === 0 ? 0 : indexOfFirstItem + 1}</b>{" "}
            to <b>{Math.min(indexOfLastItem, totalApplications)}</b> of{" "}
            <b>{totalApplications}</b> entries
          </small>
        </Card.Footer>

        {/* Modals */}
        <React.Fragment>
          <Modal
            as={Modal.Dialog}
            centered
            show={showDefault}
            onHide={handleClose}
          >
            <Modal.Header>
              <Modal.Title className="h6">Application Notes</Modal.Title>
              <Button
                variant="close"
                aria-label="Close"
                onClick={handleClose}
              />
            </Modal.Header>
            <Modal.Body>{/* Notes content here */}</Modal.Body>
            <Modal.Footer>
              <Button
                variant="danger"
                className="ms-auto"
                onClick={handleClose}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            as={Modal.Dialog}
            centered
            show={showDefaults}
            onHide={handleCloses}
          >
            <Form>
              <Modal.Header>
                <Modal.Title className="h6">
                  Update Application Status
                </Modal.Title>
                <Button
                  variant="close"
                  aria-label="Close"
                  onClick={handleCloses}
                />
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Col md={6} className="mb-3">
                    <Form.Group id="application">
                      <Form.Label>Application Status</Form.Label>
                      <Form.Select
                        // defaultValue="0"
                        value={applicationStatus}
                        onChange={handleStatusChange}
                      >
                        <option value="0">Application Approved</option>
                        <option value="1">Application Declined</option>
                        <option value="2">Application Suspended</option>
                        <option value="3">Incomplete Application</option>
                        <option value="4">Waiting For Merchant</option>
                        <option value="5">Waiting For Bank</option>
                         <option value="6">Waiting For Agent</option>
                        <option value="7">Application Applied</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  {/* <Col md={6} className="mt-4 mb-3">
                    <Form.Check
                      label="Send Auto Reply Message"
                      id="checkbox1"
                      htmlFor="checkbox1"
                    />
                  </Col> */}
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="primary"
                  onClick={() => handleSave(selectedApplicationId)}
                  disabled={loading}
                >
                  {loading ? "Saving..." : "Save"}
                </Button>
                <Button
                  variant="danger"
                  className="ms-auto"
                  onClick={handleCloses}
                >
                  Close
                </Button>
              </Modal.Footer>
            </Form>
          </Modal>

          {/* Delete confirmation modal */}
          <Modal
            as={Modal.Dialog}
            centered
            show={showDeleteModal}
            onHide={handleDeleteClose}
          >
            <Modal.Header>
              <Modal.Title className="h6">Delete Application</Modal.Title>
              <Button
                variant="close"
                aria-label="Close"
                onClick={handleDeleteClose}
              />
            </Modal.Header>
            <Modal.Body>
              Are you sure you want to delete this application?
            </Modal.Body>
            <Modal.Footer>
              <Button variant="danger" onClick={() => handleDelete(deleteId)}>
                Delete
              </Button>
              <Button variant="secondary" onClick={handleDeleteClose}>
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        </React.Fragment>
      </Card.Body>
    </Card>
    </>
  );
};
